import React from "react";
import {
  FaAddressBook,
  FaCheckCircle,
  FaHome,
  FaImages,
  FaPalette,
  FaUniversity,
} from "react-icons/fa";

import {
  formatNumber,
  getCompletionPercent,
} from "../utils/parametresUtils";

const cards = [
  {
    key: "identity",
    label: "Identité",
    helper: "Club et logo",
    icon: FaUniversity,
    filledKey: "identityFilled",
    totalKey: "identityTotal",
    tone: "bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-300",
  },
  {
    key: "contact",
    label: "Coordonnées",
    helper: "Contact et réseaux",
    icon: FaAddressBook,
    filledKey: "contactFilled",
    totalKey: "contactTotal",
    tone:
      "bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-300",
  },
  {
    key: "home",
    label: "Accueil",
    helper: "Header et about",
    icon: FaHome,
    filledKey: "homeFilled",
    totalKey: "homeTotal",
    tone:
      "bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-300",
  },
  {
    key: "galleries",
    label: "Galeries",
    helper: "Albums disponibles",
    icon: FaImages,
    valueKey: "galleriesCount",
    tone:
      "bg-violet-50 text-violet-600 dark:bg-violet-500/10 dark:text-violet-300",
  },
  {
    key: "logo",
    label: "Logo",
    helper: "Identité visuelle",
    icon: FaCheckCircle,
    booleanKey: "hasLogo",
    tone: "bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-300",
  },
  {
    key: "color",
    label: "Couleur",
    helper: "Thème principal",
    icon: FaPalette,
    booleanKey: "hasPrimaryColor",
    tone: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
  },
];

export default function SettingsStats({ loading, stats }) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-6">
      {cards.map((card) => {
        const Icon = card.icon;

        let value = "—";

        if (card.valueKey) {
          value = formatNumber(stats?.[card.valueKey]);
        }

        if (card.booleanKey) {
          value = stats?.[card.booleanKey] ? "OK" : "—";
        }

        if (card.filledKey) {
          value = `${getCompletionPercent(
            stats?.[card.filledKey],
            stats?.[card.totalKey]
          )}%`;
        }

        return (
          <article
            key={card.key}
            className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 transition hover:-translate-y-1 hover:shadow-lg hover:shadow-slate-200/80 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none"
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
                  {card.label}
                </p>

                {loading ? (
                  <div className="mt-3 h-8 w-16 animate-pulse rounded-xl bg-slate-100 dark:bg-slate-800" />
                ) : (
                  <p className="mt-2 text-3xl font-bold text-slate-950 dark:text-white">
                    {value}
                  </p>
                )}

                <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                  {card.helper}
                </p>
              </div>

              <span
                className={`grid h-11 w-11 shrink-0 place-items-center rounded-2xl ${card.tone}`}
              >
                <Icon />
              </span>
            </div>
          </article>
        );
      })}
    </section>
  );
}